export const shadows = {
  mainShadow: '0px 4px 20px $colors$neutral200',
  cardShadow: '0px 2px 8px $colors$neutral200',
}
